import React from "react";
import { CHECKOUT_URL, goToCheckout } from "../utils/pixel";
type CtaButtonProps = {
  label: string;
  /** "offer" scrolls to #offer-details, "checkout" opens the payment page */
  action: "offer" | "checkout";
  size?: "md" | "lg";
  className?: string;
};
export function CtaButton({
  label,
  action,
  size = "lg",
  className = ""
}: CtaButtonProps) {
  const href = action === "checkout" ? CHECKOUT_URL : "#offer-details";
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (action === "checkout") {
      goToCheckout();
      return;
    }
    document.getElementById("offer-details")?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };
  const sizing = size === "lg" ? "px-7 py-4 text-xl sm:px-9 sm:py-5 sm:text-2xl" : "px-6 py-3.5 text-lg";
  return <a href={href} onClick={handleClick} className={`inline-flex items-center justify-center rounded-2xl bg-cta text-center font-display font-bold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_#15803D] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-ctahover active:translate-y-1 active:shadow-[0_2px_0_#15803D] ${sizing} ${className}`} data-id="element-46" data-mp="19buvp52lpdou">
      {label}
    </a>;
}